<template #AllUsers>
    <div id="all-users">
        <div class="all-users-container">
            <ComingSoonWrapper />

            <div class="header">
                <FilterTool />
            </div>
            <div
                v-if="!data.length"
                class="h-50 d-flex flex-column justify-content-center align-items-center text-align-center"
            >
                <a-spin />
                <p>{{ $t("message.loading") }}</p>
            </div>
            <LineGraphic v-else :data="data" :total-data="totalData" :avg-data="avgData" sub-title="allUsers" />
        </div>
    </div>
</template>
<script>
import SideMenuBar from "../../SideMenuBar";
import FilterTool from "../archive/FilterTool";
import LineGraphic from "../../components/LineGraphic";
import ChartNotFound from "../../components/ChartNotFound";
import ComingSoonWrapper from "./ComingSoonWrapper";

import { IS_CHARTS_PUBLIC } from "../../chatbot";
import { mapMutations } from "vuex";
import ChatbotMenu from "../../ChatbotMenu.vue";

export default {
    name: "AllUsers",
    components: { ChatbotMenu, ChartNotFound, LineGraphic, FilterTool, SideMenuBar, ComingSoonWrapper },
    data() {
        return {
            IS_CHARTS_PUBLIC,
            data: [
                { value: 1, date: "01-02-2022" },
                { value: 12, date: "01-03-2022" },
                { value: 15, date: "01-04-2022" },
                { value: 2, date: "01-05-2022" },
                { value: 8, date: "01-06-2022" },
                { value: 20, date: "01-07-2022" },
            ],
            totalData: { message: this.$t("chatbotv2.totalData"), value: 0 },
            avgData: { message: this.$t("chatbotv2.avgData"), value: 0 },
        };
    },
};
</script>
<style lang="scss">
#all-users {
    width: 100%;
    display: flex;
    height: 100vh;

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .all-users-container {
        width: 100%;

        .header {
            width: 100%;
        }

        .chart {
            max-width: 1050px;
        }
    }
}
</style>
